import _ from "lodash";
import moment, { type Moment } from "moment";
import type { TFunction } from "src/design-system/core/TranslationContext";
import type { IdName } from "src/types/IdName";
import { formatTimeSlot, parseTime } from "./formatters";

export const buildHoursSlot = (translateCommon: TFunction): IdName[] => {
    const hours: IdName[] = [];
    _.range(5, 29).forEach((hour) => {
        hours.push({ id: hour, name: formatTimeSlot(`${hour}:${0}`, translateCommon) });
        if (hour !== 29) {
            hours.push({ id: hour + 0.3, name: formatTimeSlot(`${hour}:${30}`, translateCommon) });
        }
    });
    hours.push({ id: 28.59, name: formatTimeSlot(`${28}:${59}`, translateCommon) });
    return hours;
};

export const roundToHalf = (date: Moment): number => {
    const p = 30 * 60 * 1000;

    return Math.round(date.valueOf() / p) * p;
};

export const formatHoursToSlot = (slot: string, translateCommon: TFunction): number => {
    const { hours, minutes } = parseTime(slot, translateCommon);

    if (minutes !== undefined) {
        return hours + minutes / 100;
    }

    return hours;
};

export const formatSlotToTime = (time: string | number, translateCommon: TFunction): string => {
    if (!time) {
        return "";
    }

    const [hours, minutes] = Number.parseFloat(time as string)
        .toFixed(2)
        .split(".")
        .map((n) => Number.parseInt(n, 10));

    const slot = `${hours}:${minutes}`;

    return formatTimeSlot(slot, translateCommon);
};

export const formatSlotToDuration = (time: string | number): moment.Duration | null | undefined => {
    if (time === null || time === undefined) {
        return time as null | undefined;
    }

    const [hours, minutes] = Number.parseFloat(time as string)
        .toFixed(2)
        .split(".")
        .map((n) => Number.parseInt(n, 10));

    return moment.duration({ hours, minutes });
};
